export default __webpack_public_path__ + "static/media/EP.57d83eed.png";